import { Component } from '@opten/compiler/metadata/component';
import { debounce } from '@opten/reactive/debounce';
import { isPad } from '../../utilities/detection';
import { ScrollMagicController } from '../magic-scroll';

declare const ScrollMagic: any;
declare const Swiper: any;

@Component({ className: 'js-parallax-slider' })
export class ParallaxSliderComponent {
	constructor(public element: HTMLElement) {
		const swiper = new Swiper(
			this.element.querySelector('.js-parallax-slider-content-slider'),
			{
				parallax: true,
				effect: 'fade',
				fadeEffect: {
					crossFade: true,
				},
				speed: 500,
				allowTouchMove: false
			}
		);

		const slides = document.querySelectorAll('.js-parallax-slider-media');
		slides.forEach((slide, i) => {
			const isLastSlide = i == slides.length - 1;
			const scene = new ScrollMagic.Scene({
				triggerElement: slide,
				triggerHook: 'onLeave',
				duration: isLastSlide ? '0.001%' : '60%',
			})
				.setPin(slide, { pushFollowers: false })
				.addTo(ScrollMagicController);
			scene.on('progress', (ev) => {
				if (ev.progress < 0.5) {
					swiper.slideTo(i);
				} else if(isLastSlide === false) {
					swiper.slideTo(i + 1);
				}
			});
		});

		const headerHeight = isPad() ? 71 : 105;
		const stickyScene = new ScrollMagic.Scene({
			triggerElement: this.element,
			triggerHook: 'onLeave',
			offset: -headerHeight,
			duration: this.element.clientHeight - slides[slides.length - 1].clientHeight,
		})
			.setPin(this.element.querySelector('.js-parallax-slider-content'), {
				pushFollowers: false
			})
			.addTo(ScrollMagicController);

		window.addEventListener(
			'resize',
			debounce(() => {
				ScrollMagicController.update(true);
				stickyScene.duration(this.element.clientHeight - slides[slides.length - 1].clientHeight);
				stickyScene.offset((isPad() ? 71 : 105) * -1);
			}, 100)
		);
	}
}
